import { Link } from "react-router-dom";

const EconomicCalendarContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/economic_calendar/economic_calendar_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>How to Use the Economic Calendar</h2>
              <p>
                Access the calendar from any device to track upcoming events by
                country, importance, or time frame. Each listing includes
                detailed forecasts, previous data, and market impact levels,
                helping you prepare for price movements before they happen.
                Whether you’re a short-term trader reacting to NFP data or a
                long-term investor following interest rate trends, The Pips
                Economic Calendar keeps you informed and ready to act with
                confidence. You can set alerts for high-impact events to ensure
                you never miss crucial market catalysts. With intuitive
                navigation and real-time updates, the calendar helps streamline
                your planning and enhance your overall trading strategy.
              </p>
              {/* <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Register now
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EconomicCalendarContentTwo;
